var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"count_wrap",attrs:{"for":"banner_group_name"}},[_c('span',{staticClass:"count",class:{
      counting: _vm.text.length < _vm.maxLength,
      max: _vm.text.length >= _vm.maxLength,
    }},[_vm._v(_vm._s(_vm.text.length))]),_vm._v("/"+_vm._s(_vm.maxLength)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }